import {StyleSheet, Platform} from 'react-native';
import {responsiveWidth} from '../../components/customResponsiveDimension';

export default StyleSheet.create({
  containerStyle: {flex: 1, flexDirection: 'row'},
  subContainerStyle: {
    paddingTop: '5%',
    paddingBottom: Platform.OS === 'web' ? '0%' : '5%',
    flexDirection: 'column',
    flex: 0.72,
    paddingLeft: responsiveWidth(10),
  },
  subContainerStyle_XXXHDPI: {
    flexDirection: 'column',
    flex: 1,
    paddingLeft: 0,
    marginHorizontal: responsiveWidth(12)
  },
  subContainerStyle_XXHDPI: {
    flexDirection: 'column',
    flex: 1,
    paddingLeft: 0,
    marginHorizontal: responsiveWidth(12)
  },

  subContainerStyle_XHDPI: {
    flexDirection: 'column',
    flex: 1,
    paddingLeft: 0,
    marginHorizontal: responsiveWidth(3)
  },
  subContainerStyle_HDPI: {
    flexDirection: 'column',
    flex: 1,
    paddingLeft: 0,
    marginHorizontal: responsiveWidth(3)
  },
  subContainerStyle_MDPI: {
    flexDirection: 'column',
    flex: 1,
    paddingLeft: 0,
    marginHorizontal: responsiveWidth(3)
  },
  subContainerStyle_LDPI: {
    flexDirection: 'column',
    flex: 1,
    paddingLeft: 0,
    marginHorizontal: responsiveWidth(3)
  },
  rowStyle: {
    flexDirection: 'row',
    marginTop: '2%'
  },
  rowStyle_XHDPI: {flexDirection: 'column'},
  rowStyle_HDPI: {flexDirection: 'column'},
  rowStyle_MDPI: {flexDirection: 'column'},
  rowStyle_LDPI: {flexDirection: 'column'},
  statusTextStyle: {
    marginLeft: '27%',
    justifyContent: 'center',
    alignItems: 'center',
  },
  statusTextStyle_XHDPI: {marginLeft: 0, marginTop: '2%'},
  statusTextStyle_HDPI: {marginLeft: 0, marginTop: '2%'},
  statusTextStyle_MDPI: {marginLeft: 0, marginTop: '2%'},
  statusTextStyle_LDPI: {marginLeft: 0, marginTop: '2%'},
  buttonStyle: {flex: 0.5, marginLeft: 10, marginVertical: 10},
  buttonStyle_XXXHDPI: {flex: 0.5, marginLeft: 0, marginTop: 10},
  buttonStyle_XXHDPI: {flex: 0.5, marginLeft: 20, marginTop: 10},
  buttonStyle_XHDPI: {flex: 0.5, marginLeft: 0, marginTop: 10},
  buttonStyle_HDPI: {flex: 0.5, marginLeft: 0, marginTop: 10},
  buttonStyle_MDPI: {flex: 0.5, marginLeft: 0, marginTop: 10},
  buttonStyle_LDPI: {flex: 0.5, marginLeft: 0, marginTop: 10},
  uploadButtonStyle: {
    marginLeft: 10,
    marginVertical: 10,
    justifyContent: 'center',
    alignItems: 'center',
    borderWidth: 1,
    borderColor: '#182340',
    borderRadius: 30,
    paddingHorizontal: 25,
    paddingVertical: 15
  },
  uploadButtonStyle_XXXHDPI: {
    flex: 0.5,
    marginLeft: 10,
    marginTop: 10,
    marginVertical: 0
  },
  
  uploadButtonStyle_XXHDPI: {
    flex: 0.5,
    marginLeft: 20,
    marginTop: 10,
    marginVertical: 0
  },
  uploadButtonStyle_XHDPI: {
    flex: 0.5,
    marginLeft: 0,
    marginTop: 6,
    marginVertical: 0
  },
  uploadButtonStyle_HDPI: {
    flex: 0.5,
    marginLeft: 0,
    marginTop: 6,
    marginVertical: 0
  },
  uploadButtonStyle_MDPI: {
    flex: 0.5,
    marginLeft: 0,
    marginTop: 6,
    marginVertical: 0
  },
  uploadButtonStyle_LDPI: {
    flex: 0.5,
    marginLeft: 0,
    marginTop: 6,
    marginVertical: 0
  },
  buttonContainerStyle: {
    flexDirection: 'row',
    marginTop: 40,
    marginBottom: '2%'
  },
  buttonContainerStyle_XXXHDPI: {
    flexDirection: 'row'
  },
  buttonContainerStyle_XXHDPI: {
    flexDirection: 'row'
    // width: '35%',
  },
  buttonContainerStyle_XHDPI: {
    flexDirection: 'column-reverse'
  },
  buttonContainerStyle_HDPI: {
    flexDirection: 'column-reverse'
  },
  buttonContainerStyle_MDPI: {
    flexDirection: 'column-reverse'
  },
  buttonContainerStyle_LDPI: {
    flexDirection: 'column-reverse'
  },

  saveButtonStyle: {
    //   width: '50%',
    width: '25%', // changed to 25% for laptop resolution
    marginRight: '4%'
  },
  saveButtonStyle_XXXHDPI: {
    width: '50%',
    marginRight: '4%'
  },
  saveButtonStyle_XXHDPI: {
    width: '50%',
    marginRight: '4%'
  },
  saveButtonStyle_XHDPI: {
    width: '100%',
    marginRight: 0,
    marginBottom: '4%'
  },
  saveButtonStyle_HDPI: {
    width: '100%',
    marginRight: 0,
    marginBottom: '4%'
  },
  saveButtonStyle_MDPI: {
    width: '100%',
    marginRight: 0,
    marginBottom: '4%'
  },
  saveButtonStyle_LDPI: {
    width: '100%',
    marginRight: 0,
    marginBottom: '4%'
  },
  cancelButtonStyle: {
    width: '20%',
    marginRight: '4%'
  },
  cancelButtonStyle_XXXHDPI: {
    width: '20%',
    marginRight: '4%'
  },
  cancelButtonStyle_XXHDPI: {
    width: '20%',
    marginRight: '4%'
  },
  cancelButtonStyle_XHDPI: {
    width: '100%',
    marginRight: 0
  },
  cancelButtonStyle_HDPI: {
    width: '100%',
    marginRight: 0
  },
  cancelButtonStyle_MDPI: {
    width: '100%',
    marginRight: 0
  },
  cancelButtonStyle_LDPI: {
    width: '100%',
    marginRight: 0
  },
  dropdownStyle: {
    flexDirection: 'row',
    flex: 1,
    width: 320,
    paddingRight: 20
  },
  dropdownStyle_XXXHDPI: {
    width: 320,
    paddingRight: 0
  },
  dropdownStyle_XXHDPI: {
    width: 320,
    paddingRight: 0
  },
  dropdownStyle_XHDPI: {
    width: '100%',
    paddingRight: 0
  },
  dropdownStyle_HDPI: {
    width: '100%',
    paddingRight: 0
  },
  dropdownStyle_MDPI: {
    width: '100%',
    paddingRight: 0
  },
  dropdownStyle_LDPI: {
    width: '100%',
    paddingRight: 0
  },
  menu_option_hovered: {
    flexDirection: 'row',
    padding: 10,
    backgroundColor: '#097dfa'
  },

  menu_option_hovered_gray: {
    flexDirection: 'row',
    padding: 10,
    backgroundColor: '#d3d3d3'
  },
  menu_option_normal: {
    flexDirection: 'row',
    padding: 10
  },
  srNumberStyle: {flexDirection: 'column', width: 320},
  srNumberStyle_XXXHDPI: {width: '100%'},
  srNumberStyle_XXHDPI: {width: '100%'},
  srNumberStyle_XHDPI: {width: '100%'},
  srNumberStyle_HDPI: {width: '100%'},
  srNumberStyle_MDPI: {width: '100%'},
  srNumberStyle_LDPI: {width: '100%'},

  srNumberStyleindividual: {flexDirection: 'column', width: 320},
  srNumberStyleindividual_XXXHDPI: {width: 320},
  srNumberStyleindividual_XXHDPI: {width: 320},
  srNumberStyleindividual_XHDPI: {width: '100%', marginTop: '5%'},
  srNumberStyleindividual_HDPI: {width: '100%', marginTop: '5%'},
  srNumberStyleindividual_MDPI: {width: '100%', marginTop: '5%'},
  srNumberStyleindividual_LDPI: {width: '100%', marginTop: '5%'},
  subHeaderStyle: {
    fontSize: 24,
    fontWeight: 'bold',
    marginLeft: responsiveWidth(8.5),
    color: '#FFFFFF'
  },
  subHeaderStyle_XHDPI: {
    marginLeft: null,
    marginHorizontal: responsiveWidth(1.5)
  },
  subHeaderStyle_HDPI: {
    marginLeft: null,
    marginHorizontal: responsiveWidth(1.5)
  },
  subHeaderStyle_MDPI: {
    marginLeft: null,
    marginHorizontal: responsiveWidth(1.5)
  },
  subHeaderStyle_LDPI: {
    marginLeft: null,
    marginHorizontal: responsiveWidth(1.5)
  },
  buttonStyleBusiness: {flex: 0.8, marginLeft: 0, marginVertical: 10},
  buttonStyleBusiness_XHDPI: {flex: 0.5, marginLeft: 0, marginTop: 10},
  buttonStyleBusiness_HDPI: {flex: 0.5, marginLeft: 0, marginTop: 10},
  buttonStyleBusiness_MDPI: {flex: 0.5, marginLeft: 0, marginTop: 10},
  buttonStyleBusiness_LDPI: {flex: 0.5, marginLeft: 0, marginTop: 10},
  itemNameContainerStyle: {
    width: responsiveWidth(35),
    justifyContent: 'center'
  },
  itemNameContainerStyle_XXXHDPI: {width: responsiveWidth(35), marginTop: '5%'},
  itemNameContainerStyle_XXHDPI: {width: responsiveWidth(35), marginTop: '5%'},
  itemNameContainerStyle_XHDPI: {width: responsiveWidth(35), marginTop: '5%'},
  itemNameContainerStyle_HDPI: {width: '100%', marginTop: '5%'},
  itemNameContainerStyle_MDPI: {width: '100%', marginTop: '5%'},
  itemNameContainerStyle_LDPI: {width: '100%', marginTop: '5%'},

  textInputStyle: {
    width: '100%'
  },
  textInputStyle_LAPTOP: {
    width: '38%'
  },
  textInputStyle_XXXHDPI: {
    width: '38%'
  },
  textInputStyle_XXHDPI: {
    width: '38%'
  },
  textInputStyle_XHDPI: {
    width: '38%'
  },

  textInputStylePower: {
    width: '100%',
    flexDirection: 'row',
    alignItems: 'center'
  },
  textInputStylePower_LAPTOP: {
    width: '55%'
  },
  textInputStylePower_XXXHDPI: {
    width: '38%'
  },
  textInputStylePower_XXHDPI: {
    width: '50%'
  },
  textInputStylePower_XHDPI: {
    width: '38%'
  },
  containerWidth: {
    width: '100%',
    flexDirection: 'column'
  },
  containerWidth_LAPTOP: {
    width: '70%'
  },
  sourceOfFundStyle: {
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center'
  },
  sourceOfFundStyle_LAPTOP: {
    flexDirection: 'row'
  },
  sourceOfFundStyle_XXHDPI: {
    flexDirection: 'row'
  },
  infoTipStyleMain: {display: 'none'},
  infoTipStyleMain_LAPTOP: {display: 'flex'},
  infoTipStyleMain_XXXHDPI: {display: 'flex'},
  infoTipStyleMain_XXHDPI: {display: 'flex'},
  infoTipStyle: {display: 'flex'},
  infoTipStyle_LAPTOP: {display: 'none'},
  infoTipStyle_XXXHDPI: {display: 'none'},
  infoTipStyle_XXHDPI: { display: 'none' },
  uploadDocumentHeader: {
    fontSize: 24,
    color: '#132c6e',
    width: '100%',
    fontWeight: 'bold'
  },
  textHead: {
    fontSize: 16,
    color: '#9b9b9b',
    width: '100%',
    marginTop: '4%',
    fontStyle: 'italic'
  },
  textHead_LDPI: {
    marginTop: '5%',
  },
  textHead_MDPI: {
    marginTop: '5%',
  },
  textSubHead: {
    fontSize: 16,
    color: '#9b9b9b',
    width: '100%',
    marginTop: '1%',
    fontStyle: 'italic'
  },
  textSubHead_LDPI: {
    marginTop: '5%',
  },
  textSubHead_MDPI: {
    marginTop: '5%',
  },
  fileFormatText: {
    fontSize: 12,
    color: '#9b9b9b',
    width: '100%',
    marginTop: '3%'
  },
  fileFormatText_LDPI: {
    marginTop: '5%',
  },
  fileFormatText_MDPI: {
    marginTop: '5%',
  },
});